// Frontend scripts for Divi 4 Arketa Marketing Widgets.
// The Arketa embed.js script handles all iframe communication.
